// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__2FVKW","frame":"Dialog_frame__MIK58","closeButton":"Dialog_closeButton__2deKm","okButton":"Dialog_okButton__2jGk_","body":"Dialog_body__13JA0"};